import '../../../util/string';
import '../../../util/array';
import React, { Component, forwardRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, TextField } from '@material-ui/core';
import MaterialTable from 'material-table';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import Modal from '../../../components/Modal/modal';
import DragAndDrop from '../../../components/NewPatient/Photos/DragAndDrop';
import style from './PageBanner.module.css';
import axios from '../../../axios-default';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Url from 'url';
import join from 'url-join';
import { ApiServerUrl } from '../../../config.json';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { easySnackbar } from '../../../store/Noti/noti.actions';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { loadConfig } from '../../../store/config/config.action';
import { safeGet } from '../../../../src/axios-default';
import { getWebAbsPath } from '../../../util/path';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const DEFAULT_BANNER = getWebAbsPath('/img/bannerSmall.png');

const styles = (theme) => ({
    modalContainer: {
        height: '80vh',
    },
});

class PageBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            banner_list: [],
            distr_list: {},
            // valuePath: 'banner',
            // data: [],
            // newImage: null,
            // photoUploadLoadingStatus: false,
            bannerModalOpen: false,
            banners: [],
            deletedBanners: [],
            distrId: 0,
            hideDragAndDrop: false,
            // role: JSON.parse(localStorage.getItem('role'))
        };
    }

    showDatabyDistributor = () => {};

    actions = [
        {
            icon: () => <EditOutlinedIcon />,
            tooltip: 'Edit Banner',
            onClick: (_, data) => {
                this.setState({
                    bannerModalOpen: true,
                    banners: data.banners,
                    distrId: data.distr_group_id,
                });
            },
        },
        (row) => ({
            icon: () => <DeleteOutlineOutlinedIcon />,
            tooltip: 'Delete Banner',
            hidden: row.distr_group_id == 0,
            onClick: async (_, data) => {
                if (window.confirm('Do you want to delete this banner?')) {
                    try {
                        await axios.post('config/deleteBannerSet', {
                            distr_group_id: data.distr_group_id,
                        });
                        await this.props.relaodConfig();
                        this.setState(
                            {
                                banners: {},
                            },
                            () => {
                                this.componentDidMount();
                            }
                        );
                    } catch (err) {
                        console.error(err);
                        if (err.response && err.response.statusText === 'Unauthorized') {
                            localStorage.removeItem('auth-token');
                            localStorage.removeItem('expirationDate');
                            localStorage.removeItem('role');
                            this.props.history.push('/login');
                        }
                    }
                }
            },
        }),
    ];

    // getValueFromConfig = config => config[this.state.valuePath]

    handleAddBannerError = (addBannerData) => {
        if (isNaN(addBannerData.distr_group_id)) {
            throw new Error('No distr_group_id');
        }
        if (addBannerData.banners.length === 0) {
            throw new Error('No banners');
        }
    };

    handleAddBanner = async (data) => {
        try {
            // await axios.post('config', {
            //   country_id: data.country_id,
            //   state_province_id: data.state_province_id,
            //   user_id: data.user_id,
            //   config: JSON.stringify({
            //     banner: data.banners.filter(({ url }) => String.isNotBlank(url))
            //   })
            // })
            // await this.props.relaodConfig()
            // this.setState({
            //   loading: true
            // }, () => {
            //   this.componentDidMount()
            // })

            const addBannerArray = [];
            data.banners.forEach((v, rank) => {
                addBannerArray.push({
                    id: null,
                    img: v,
                    url: '',
                });
            });

            const addBannerData = {
                distr_group_id: parseInt(data.distr_group_id),
                banners: addBannerArray,
            };

            this.handleAddBannerError(addBannerData);

            //TODO: guard the same distr_group_id, cannot upload
            await axios.post('config/updateBannerSet', addBannerData);
            this.componentDidMount();
        } catch (err) {
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                this.props.history.push('/login');
            } else {
                if (err.message === 'No distr_group_id') {
                    this.props.enqueSnackbar('Please select distributor group to submit banner', 'error');
                } else if (err.message === 'No banners') {
                    this.props.enqueSnackbar('Please select banner to submit', 'error');
                } else {
                    this.props.enqueSnackbar('Error occurred', 'error');
                }
                throw err;
            }
        }
    };

    handleSaveBanner = async () => {
        try {
            const data = {
                distr_group_id: this.state.distrId,
                banners: this.state.banners,
            };
            const deletedBannerData = {
                distr_group_id: this.state.distrId,
                banners: this.state.deletedBanners,
            };

            await axios.post('config/updateBannerSet', data);
            if (deletedBannerData.banners.length !== 0) {
                await axios.post('config/deleteBanner', deletedBannerData);
            }

            await this.props.relaodConfig();
            this.props.enqueSnackbar('Save successfully', 'success');
            this.setState(
                {
                    bannerModalOpen: false,
                },
                () => {
                    this.componentDidMount();
                }
            );
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                this.props.history.push('/login');
            }
        }
    };

    fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            if (file !== undefined) {
                reader.readAsDataURL(file);
            }
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    handleNewBanner = async (file) => {
        let data = undefined;
        if (file) {
            data = await this.fileToBase64(file);
        }
        this.setState({
            banners: [
                ...(this.state.banners ?? []),
                {
                    img: data,
                    url: '',
                    id: null,
                },
            ],
        });
    };

    removeBanner = (index) => {
        let bannerArray = this.state.banners;
        let deletedBanner = bannerArray.splice(index, 1);
        this.setState({ banners: bannerArray });

        this.state.deletedBanners.push(...deletedBanner);
    };

    reorder = ({ source, destination }) => {
        if (source && destination) {
            let newItems = [...this.state.banners];
            const [remove] = newItems.splice(source.index, 1);
            newItems.splice(destination.index, 0, remove);
            this.setState({ banners: newItems });
        }
        this.setState({ hideDragAndDrop: false });
    };

    showImage = (path) => {
        const pattern = /^file\/config/;
        if (pattern.test(path)) {
            return ApiServerUrl + path;
        } else {
            return path;
        }
    };
    getDistributorId = () => {
        const distrGroupId = JSON.parse(localStorage.getItem('distr_group_id'));
        return distrGroupId === 'null' ? 0 : parseInt(distrGroupId);
    };

    async componentDidMount() {
        try {
            const { banner_list } = await safeGet(`config/getBannerByDistr/${this.getDistributorId()}}`);
            const { distr_list } = await safeGet('config/getDistrList');
            let dl = { 0: 'Default' };
            if (Array.isArray(distr_list)) {
                distr_list.forEach((v) => {
                    dl[v.distr_group_id] = v.distr_group_name;
                });
            }

            this.setState({ banner_list, distr_list: dl });
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                this.props.history.push('/login');
            }
        }
    }

    selectOption = (distrList, bannerList) => {
        const distrGroupId = this.getDistributorId();
        if (distrGroupId === 0) {
            const keysToRemove = new Set(bannerList.map((item) => String(item.distr_group_id)));
            const newData = {};

            for (const key in distrList) {
                if (!keysToRemove.has(key)) {
                    newData[key] = distrList[key];
                }
            }

            return newData;
        } else {
            if (bannerList.length === 1) {
                return {};
            } else {
                const selectedOption = { [distrGroupId]: distrList[distrGroupId] || {} };
                return selectedOption;
            }
        }
    };

    getColumns = () => [
        {
            title: 'Distributor Group',
            field: 'distr_group_id',
            defaultSort: 'asc',
            lookup: this.selectOption(this.state.distr_list, this.state.banner_list),
            render: (row) => {
                let name;
                Object.entries(this.state.distr_list).forEach(([key, value]) => {
                    if (parseInt(key) === parseInt(row.distr_group_id)) {
                        name = value;
                    }
                });
                return name;
            },
        },
        {
            title: 'Banners',
            field: 'banners',
            render: (row) => (
                <Grid container style={{ maxHeight: '200px', width: '400px' }}>
                    {!this.state.isLoading && (
                        <Carousel
                            showArrows={false}
                            autoPlay={row.banners.length > 1}
                            infiniteLoop
                            showThumbs={false}
                            swipeable={true}
                            emulateTouch
                            transitionTime={500}
                            interval={2000}
                            renderIndicator={() => <div />}
                        >
                            {row.banners.map((banner, i) => {
                                let content = (
                                    <img
                                        src={this.showImage(banner.img)}
                                        style={{ display: 'block' }}
                                        // onError={({ target }) => {
                                        //   let u = Url.parse(target.src)
                                        //   target.src = (
                                        //     u.pathname === '/' || u.pathname.startsWith('/img')
                                        //       ? ''
                                        //       : getWebAbsPath('/img/bannerSmall.jpg')
                                        //   )
                                        // }}
                                    />
                                );
                                if (String.isNotBlank(banner.url)) {
                                    content = (
                                        <a key={i} href={banner.url} target="_blank" style={{ display: 'block' }}>
                                            {content}
                                        </a>
                                    );
                                }
                                return <div key={`banner-image-${i}`}>{content}</div>;
                            })}
                        </Carousel>
                    )}
                </Grid>
            ),
            editComponent: (props) => (
                <>
                    <DragDropContext
                        onDragEnd={(event) => {
                            const { source, destination } = event;
                            if (!destination) {
                                return;
                            }
                            const [removed] = props.value.splice(source.index, 1);
                            props.value.splice(destination.index, 0, removed);
                            props.onChange(props.value);
                            this.setState({ hideDragAndDrop: false });
                        }}
                    >
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div {...provided.droppableProps} ref={provided.innerRef}>
                                    {(Array.ensureArray(props.value) || []).map((banner, i) => (
                                        <Draggable key={i} draggableId={`photo_${i}`} index={i}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                >
                                                    <div className={style.imageUploadArea}>
                                                        <button
                                                            className={style.remove}
                                                            onClick={() => {
                                                                props.value.splice(i, 1);
                                                                props.onChange(props.value);
                                                            }}
                                                        >
                                                            <DeleteOutlineOutlinedIcon />
                                                        </button>
                                                        <img
                                                            style={{ width: '100%', maxHeight: '400px' }}
                                                            src={this.showImage(banner)}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                    <DragAndDrop
                        handleDrop={async (file) => {
                            const data = await this.fileToBase64(file);
                            props.onChange([...(props.value || []), data]);
                        }}
                    >
                        <div className={style.imageUploadArea}>
                            <span>Upload New Banner</span>
                            <div className={style.uploadBtnWrapper}>
                                <button className={style.uploadBtn}>+</button>
                                <input
                                    type="file"
                                    onChange={async ({ target }) => {
                                        const data = await this.fileToBase64(target.files[0]);
                                        let value = props.value ? props.value : [];
                                        value.push(data);
                                        props.onChange(value);
                                    }}
                                    accept="image/*"
                                    name="bannerImg"
                                    id="bannerImg"
                                />
                            </div>
                        </div>
                        {/* <input type="text" name="bannerUrl" id="bannerUrl" /> */}
                    </DragAndDrop>
                </>
            ),
        },
    ];

    editable = () => {
        let isEmpty = Object.keys(this.selectOption(this.state.distr_list, this.state.banner_list)).length === 0;
        if (isEmpty) {
            return {};
        } else {
            return {
                onRowAdd: this.handleAddBanner,
            };
        }
    };

    render() {
        return (
            <>
                <Modal
                    modal="Banner"
                    title="Banner"
                    open={this.state.bannerModalOpen}
                    handleClose={() => {
                        this.setState({ bannerModalOpen: false });
                        this.componentDidMount();
                        this.setState({ deletedBanners: [] });
                    }}
                    handleDataSave={() => this.handleSaveBanner()}
                    photoUploadLoadingStatus={this.state.photoUploadLoadingStatus}
                    submitButton={true}
                >
                    <Grid container className={this.props.classes.modalContainer}>
                        <Grid item xs={12}>
                            <p>Current Images</p>
                            <DragDropContext
                                onDragEnd={this.reorder}
                                onBeforeDragStart={() => this.setState({ hideDragAndDrop: true })}
                            >
                                <Droppable droppableId="droppable">
                                    {(provided, snapshot) => (
                                        <div {...provided.droppableProps} ref={provided.innerRef}>
                                            {(this.state.banners ?? []).map((banner, i) => (
                                                <Draggable key={i} draggableId={`photo_${i}`} index={i}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <div className={style.imageUploadArea}>
                                                                <button
                                                                    className={style.remove}
                                                                    onClick={() => this.removeBanner(i)}
                                                                >
                                                                    <DeleteOutlineOutlinedIcon />
                                                                </button>
                                                                <img
                                                                    style={{ width: '100%', maxHeight: '400px' }}
                                                                    src={this.showImage(banner.img)}
                                                                />
                                                                <TextField
                                                                    fullWidth
                                                                    label="URL"
                                                                    variant="filled"
                                                                    defaultValue={banner.url}
                                                                    onChange={(e) => {
                                                                        let banners = this.state.banners;
                                                                        banners[i].url = e.target.value;
                                                                        this.setState({ banners: banners });
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                            <DragAndDrop
                                hidden={this.state.hideDragAndDrop}
                                handleDrop={(file) => this.handleNewBanner(file)}
                            >
                                <div className={style.imageUploadArea}>
                                    <span>Upload New Banner</span>
                                    <div className={style.uploadBtnWrapper}>
                                        <button className={style.uploadBtn}>+</button>
                                        <input
                                            type="file"
                                            onChange={({ target }) => this.handleNewBanner(target.files[0])}
                                            accept="image/*"
                                            name="bannerImage"
                                            id="bannerImage"
                                        />
                                    </div>
                                </div>
                            </DragAndDrop>
                        </Grid>
                    </Grid>
                </Modal>

                <MaterialTable
                    isLoading={this.state.loading}
                    title="Banner"
                    icons={tableIcons}
                    columns={this.getColumns()}
                    editable={this.editable()}
                    actions={this.actions}
                    data={this.state.banner_list}
                    options={{
                        actionsColumnIndex: -1,
                        pageSize: 20,
                    }}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    res: state.res,
});

const mapDispatchToProps = (dispatch) => ({
    enqueSnackbar: (msg, variant) => dispatch(easySnackbar(msg, variant)),
    relaodConfig: () => dispatch(loadConfig()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(PageBanner)));
